module.exports = __webpack_public_path__ + "static/media/sidebar-logout.2037c1e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-logout.svg
// module id = 799
// module chunks = 0